import React from "react";

import { useTranslation } from "react-i18next";

import { CaretDownIcon } from "@phosphor-icons/react";
import { ScoreIcon } from "~/components/ScoreIcon";
import { ColorIcon } from "~/sdks/LocalContent/components/ColorIcon";
import { ScoreValue } from "~/sdks/LocalContent/components/ScoreValue";

import type { ScoreKey } from "~/sdks/LocalContent/types";

import * as styles from "./styles";

export function Header({
  scoreKey,
  scoreValue,
  backgroundColor,
  fillColor,
  onClick,
}: {
  scoreKey: ScoreKey;
  scoreValue?: number;
  backgroundColor?: string;
  fillColor?: string;
  onClick?: () => void;
}) {
  const { t } = useTranslation(["common"]);

  return (
    <div
      role="button"
      className={styles.container}
      data-testid="categories-toggle-score-header"
      onClick={onClick}
    >
      <CaretDownIcon className={styles.caret} weight="bold" />
      <span className={styles.title}>
        <ColorIcon
          element={<ScoreIcon score={scoreKey} />}
          backgroundColor={backgroundColor}
          fillColor={fillColor}
        />
        <span className={styles.text}>
          {t(`common:scores.${scoreKey}.title`)}
        </span>
      </span>
      <ScoreValue scoreKey={scoreKey} value={scoreValue} />
    </div>
  );
}
